import { supabase } from '../supabaseClient';
import { NEXT_STATUS, selfApproved } from './debriefReview';

// ONE writer for every debrief status change.
//
// This started life inline in DebriefDetail. The review queue on Briefs needs
// approve / request-changes too, and a second copy is exactly how the two
// drift: one of them forgets to clear changes_requested_note, or writes the
// status but not the history row, and months later "how did this get
// published" has no answer for half the debriefs.
//
// The patch and the audit row are built together here so they cannot disagree.
// lib/debriefReview owns WHO may do WHAT; this owns what a transition WRITES.
export async function applyDebriefTransition({ debrief, action, note = null, actor }) {
  const to = NEXT_STATUS[action];
  if (!to) return { error: new Error(`Unknown debrief action: ${action}`) };

  const from = debrief.status;
  const nowIso = new Date().toISOString();
  const patch = { status: to };

  if (action === 'submit') { patch.submitted_at = nowIso; patch.submitted_by = actor?.id || null; }
  if (action === 'approve') {
    patch.approved_at = nowIso;
    patch.approved_by = actor?.id || null;
    patch.published_at = nowIso;
  }
  if (action === 'request_changes') {
    patch.changes_requested_at = nowIso;
    patch.changes_requested_by = actor?.id || null;
    patch.changes_requested_note = note;
  }
  // Withdrawing or resubmitting clears a previous "changes requested", so an
  // old reviewer note can't hang around looking like it's still outstanding.
  if (action === 'submit' || action === 'withdraw') {
    patch.changes_requested_at = null;
    patch.changes_requested_by = null;
    patch.changes_requested_note = null;
  }
  if (action === 'unpublish') { patch.published_at = null; patch.approved_at = null; patch.approved_by = null; }

  const { error } = await supabase.from('project_debriefs').update(patch).eq('id', debrief.id);
  if (error) return { error };

  // The trail is written second and its failure is NOT silent — a transition
  // with no record of who made it is the thing this table exists to prevent.
  const { error: historyError } = await supabase.from('debrief_status_history').insert([{
    debrief_id: debrief.id,
    from_status: from,
    to_status: to,
    action,
    note,
    self_approved: action === 'approve' && selfApproved(debrief, actor),
    actor_id: actor?.id || null,
  }]);

  return { error: null, historyError: historyError || null, from, to };
}
